module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/banner/zh-hant-50c2df41f5dcc0a1b32bf11473896abe.jpg";